import SectionService from '../../../../services/SectionService';
import {
  addAsset,
  updateAsset,
} from '../../store/slices/assetsSlice';
import {
  addTimelineItem,
} from '../../store/slices/timelineSlice';
import {
  setTextModalVisible,
  setEditingTextContext,
} from '../../store/slices/editorUISlice';

export function createTextHandlers({
  dispatch,
  currentTime,
  selectedItemId,
  currentItem,
  isEditMode,
  editingTextContext,
}) {
  const handleCreateText = (html) => {
    const id = `asset-text-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const textAsset = {
      id,
      type: 'text',
      source_type: 'upload',
      name: 'Text',
      text: html,
      duration: 5,
      metadata: { created_at: new Date().toISOString() },
    };
    dispatch({ ...addAsset(textAsset), meta: { undoable: true } });
    dispatch({ ...addTimelineItem({ assetId: textAsset.id, duration: textAsset.duration, currentTime, anchorItemId: selectedItemId || currentItem?.id }), meta: { undoable: true } });
    dispatch(setTextModalVisible(false));
    dispatch(setEditingTextContext(null));
  };

  const handleOpenEditText = (asset, item) => {
    const context = { assetId: asset.id, sectionId: asset.metadata?.sectionId || null, itemId: item.id, initialHtml: asset.text || '' };
    dispatch(setEditingTextContext(context));
    dispatch(setTextModalVisible(true));
  };

  const updateTextSection = async ({ sectionId, text }) => {
    const html = text;
    try {
      if (isEditMode && sectionId) {
        await SectionService.updateSection({ sectionId, text: html });
      }
      if (editingTextContext?.assetId) {
        dispatch({ ...updateAsset({ id: editingTextContext.assetId, changes: { text: html } }), meta: { undoable: true } });
      }
      dispatch(setTextModalVisible(false));
      dispatch(setEditingTextContext(null));
    } catch (e) {
      // noop
    }
  };

  return {
    handleCreateText,
    handleOpenEditText,
    updateTextSection,
  };
}

